import React, { FC } from 'react';
import Head from 'next/head';

interface GeneraleAndLocaleMetadataProps {
  canonicalUrl: string;
  country: string;
  noindex: boolean;
}

export const GeneralMetadata: FC<GeneraleAndLocaleMetadataProps> = ({ canonicalUrl, country, noindex }) => {
  return (
    <Head>
      <meta content="width=device-width, initial-scale=1.0,  user-scalable=0" name="viewport" />
      <meta content="text/html; charset=utf-8" httpEquiv="content-type" />
      <meta content="IE=edge,chrome=1" httpEquiv="X-UA-Compatible" />
      <meta content="en" name="language" />
      <meta content={country} name="country" />
      <meta content="2611d4b24275799f295fe3ff3512c921" name="p:domain_verify" />
      {canonicalUrl ? <link href={canonicalUrl} rel="canonical" /> : null}
      {noindex && <meta content="noindex" name="robots" />}
      {/* <base href={paths.web} /> */}
    </Head>
  );
};
